import { useSelector, shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import type { RootState } from '../store';

const builderSelector = ({ builder }: RootState) => ({
  selected: builder?.selected,
  editor: builder.editor,
  badges: builder?.badges,
  flatOutline: builder?.flatOutline,
  watchQueryParams: builder?.watchQueryParams,
  alwaysRenderInBuilder: builder?.alwaysRenderInBuilder,
});

export const useBuilder = () => {
  const builderData = useSelector(builderSelector, shallowEqual);
  return useMemo(() => builderData, [builderData]);
};
